import request from '@/utils/request'


// 查询推荐官申请列表
export function listReferrals(query) {
  return request({
    url: '/user/top-referrals/list',
    method: 'get',
    params: query
  })
}

// 查询推荐官申请分页
export function pageReferrals(query) {
  return request({
    url: '/user/top-referrals/page',
    method: 'get',
    params: query
  })
}

// 查询推荐官申请详细
export function getReferrals(data) {
  return request({
    url: '/user/top-referrals/detail',
    method: 'get',
    params: data
  })
}

// 新增推荐官申请
export function addReferrals(data) {
  return request({
    url: '/user/top-referrals/add',
    method: 'post',
    data: data
  })
}

// 修改推荐官申请
export function updateReferrals(data) {
  return request({
    url: '/user/top-referrals/edit',
    method: 'post',
    data: data
  })
}

export function updateBank(data) {
  return request({
    url: '/user/user-bank/edit',
    method: 'post',
    data: data
  })
}

// 删除推荐官申请
export function delReferrals(data) {
  return request({
    url: '/user/top-referrals/delete',
    method: 'post',
    data: data
  })
}

export function updateUserStatus(data) {
  return request({
    url: '/biz/user/updateUserStatus',
    method: 'post',
    params: data
  })
}